import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { AlertCircle, Check, Info } from 'react-feather';
import { useToasts } from '@magento/peregrine';
import Icon from '../../Icon';
var CheckIcon = React.createElement(Icon, {
  size: 20,
  src: Check
});
var ErrorIcon = React.createElement(Icon, {
  size: 20,
  src: AlertCircle
});
var InfoIcon = React.createElement(Icon, {
  size: 20,
  src: Info
});
export var useCommonToasts = function useCommonToasts(props) {
  var errorToastProps = props.errorToastProps,
      loginToastProps = props.loginToastProps,
      successToastProps = props.successToastProps;

  var _useToasts = useToasts(),
      _useToasts2 = _slicedToArray(_useToasts, 2),
      addToast = _useToasts2[1].addToast;

  useEffect(function () {
    if (loginToastProps) {
      addToast(_objectSpread({}, loginToastProps, {
        icon: InfoIcon
      }));
    }
  }, [addToast, loginToastProps]);
  useEffect(function () {
    if (successToastProps) {
      addToast(_objectSpread({}, successToastProps, {
        icon: CheckIcon
      }));
    }
  }, [addToast, successToastProps]);
  useEffect(function () {
    if (errorToastProps) {
      addToast(_objectSpread({}, errorToastProps, {
        icon: ErrorIcon
      }));
    }
  }, [addToast, errorToastProps]);
};